/* eslint-disable */
export const ZONE_FILE_TEMPLATE = `;;
;; Domain: {zone}
;; Exported: {datetime}
;;
;; This file is intended for use for informational and archival
;; purposes ONLY and MUST be edited before use on a production
;; DNS server.  In particular, you must:
;;   -- update the SOA record with the correct authoritative name server
;;   -- update the SOA record with the contact e-mail address information
;;   -- update the NS record(s) with the authoritative name servers for this domain.
;;
;; For further information, please consult the BIND documentation
;; located on the following website:
;;
;; http://www.isc.org/
;;
;; And RFC 1035:
;;
;; http://www.ietf.org/rfc/rfc1035.txt
;;
;; Please note that we do NOT offer technical support for any use
;; of this zone data, the BIND name server, or any other third-party
;; DNS software.
;;
;; Use at your own risk.

;; SOA Record
{name}{ttl}IN	SOA	{mname}{rname}{serial}{refresh}{retry}{expire}{minimum}

;; NS Records
{ns}

;; MX Records
{mx}

;; A Records
{a}

;; AAAA Records
{aaaa}

;; CNAME Records
{cname}

;; PTR Records
{ptr}

;; TXT Records
{txt}

;; SRV Records
{srv}
`
